<template>
  <main>
    <h2 class="ttl"><img src="/img/ico_pw2.png" alt="パスワードの再設定" width="40" class="mb30"><br>{{$t('passwordReset')}}</h2>
    <div class="account-box">
      <p class="txt-mail">
        <span v-if="!$v.email.required || !$v.email.email">{{$t(this.getMessage($v.email , {"name" : "メールアドレス"}))}}</span>
        <input type="email" id="email" name="email" placeholder="Email" v-model.trim="$v.email.$model">
        </p>
    </div>
    <p class="txt-error center mb40">
      <validationError :error="(this.$v.$invalid && this.vaError)"/>
      <firebaseError :error="this.fbError" :errorCode="errorCode"/>
    </p>
    <p class="btn-normal">
      <router-link to="" @click.native="resetPassword">{{$t('sendResetPasswordMail')}}</router-link>
    </p>
  </main>
</template>

<script>
import firebase from 'firebase'
import firebaseError from "@/error/FirebaseError"
import validationError from "@/error/ValidationError"
import { required , email } from "vuelidate/lib/validators"

export default {
  name: 'PasswordResetEmailSend',
  data () {
    return {
      auth: firebase.auth(),
      email: '',
      vaError : false, //バリデーションエラー
      fbError : false, //firebaseエラー
      errorCode: "",
    }
  },
  validations: {
    email: {
      required, email
    },
  },
  components: {
    firebaseError,
    validationError
  },
  methods: {
    async resetPassword () {
      this.$v.$touch()
      if(this.$v.$invalid) {
        this.vaError = true
      }
      else {
        await this.auth.sendPasswordResetEmail(this.email).then(() => {
          this.$router.push({ name: 'VerifyEmailSend' })
        }).catch((error) => {
          if (error.code == 'auth/user-not-found') {
            this.errorCode = 'auth/user-not-found2'
          } else {
            this.errorCode = error.code
          }
          this.fbError = true
          return
        })
      }
    },
  }
}
</script>
